















import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import ProcessoModel from "@/models/Processo";
import ProcessosList from "@/components/ProcessosList.vue";
import _debug from "debug";

const userModule = getModule(UserModule, store);
const debug = _debug("Mediacao:views:processo:Processos.vue");

@Component({
    components: { ProcessosList },
})
export default class Processos extends Vue {
    public carregando = true;
    private processos: ProcessoModel[] = [];

    public editarProcesso(processo: ProcessoModel) {
        debug("Editando o processo:", processo);
        this.$router.push(`/processo/${processo.id}/`);
    }

    public adicionarProcesso() {
        debug("Adicionando processo ...");
        this.$router.push(`/processo/novo/`);
    }

    private created() {
        this.carregando = true;
        this.fetchProcessos();
    }

    private async fetchProcessos() {
        const user = userModule.getUser;
        debug("MainChatsController.watchChats", user);
        if (user && user.userDb) {
            const processos = await ProcessoModel.listByUser(user.userDb.email!);
            processos.forEach(this.addToList);
            this.carregando = false;
        }
    }

    private async addToList(processo: ProcessoModel) {
        debug("Vai carregar processo com refs", processo);
        if (
            !this.processos.some(processoExistente => {
                return processo.id === processoExistente.id;
            })
        ) {
            this.processos.push(processo);
        }

        this.carregando = false;
    }
}
